import { useEffect } from 'react'
import { showNotification } from 'summon-ui'
import { useAccount } from 'wagmi'
import { TENANT_CONFIG } from '@config'
import { useChangeAddressLogout, useLogout, useTokenGating, useViewer } from '@hooks'
import { getJWT } from '@utils/auth'

const { features } = TENANT_CONFIG
const tenantHasTokenGating = features?.tokenGating

const useAuth = () => {
  const hasJWT = !!getJWT()
  const { logout } = useLogout()
  const { viewer, isLoading: isLoadingUser, status: viewerStatus } = useViewer()
  const { hasMintedZeekNFT } = useTokenGating()
  const { isConnected, address } = useAccount()
  useChangeAddressLogout()

  useEffect(() => {
    if (viewerStatus === 'success') {
      if (tenantHasTokenGating && hasMintedZeekNFT != null && viewer?.isOnboardingCompleted) {
        // We check after 2 secs to allow  the NFT minting process to complete (estimated block time)
        setTimeout(() => {
          if (!hasMintedZeekNFT) {
            showNotification({
              variant: 'danger',
              message: 'Token to enter has not been found'
            })
            logout()
          }
        }, 2000)
      }
    }
  }, [isConnected, viewer, address, hasJWT, viewerStatus, tenantHasTokenGating, hasMintedZeekNFT])

  const finishedAuthenticating =
    (!isLoadingUser &&
      viewerStatus === 'success' &&
      viewer?.isOnboardingCompleted &&
      ((tenantHasTokenGating && hasMintedZeekNFT) || !tenantHasTokenGating)) ||
    false

  return {
    finishedAuthenticating
  }
}

export default useAuth
